var render = function render(){var _vm=this,_c=_vm._self._c;return _c('worker',{attrs:{"title":"非在职员工信息管理","isDiscipline":"yes"}})
}
var staticRenderFns = []

export { render, staticRenderFns }